import { BsHomeDashboard } from './BsHomeDashboard';
export default BsHomeDashboard;
